import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../@types/RootState';

type DeleteFilterState = {
  isOpen: boolean;
};

const initialState: DeleteFilterState = { isOpen: false };

const slice = createSlice({
  name: 'ipa.priceManager.modals.deleteFilter',
  initialState,
  reducers: {
    SET_IS_OPEN(state, action: PayloadAction<boolean>) {
      state.isOpen = action.payload;
    },
  },
});

export const { SET_IS_OPEN } = slice.actions;

export default slice.reducer;

export const selectorDeleteFilter = (state: RootState) => {
  return state.ipa.priceManager.modals.deleteFilter;
};
